import { render, staticRenderFns } from "./ProductGroup.vue?vue&type=template&id=2ab69495&lang=pug&"
import script from "./ProductGroup.vue?vue&type=script&lang=js&"
export * from "./ProductGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ab69495')) {
      api.createRecord('2ab69495', component.options)
    } else {
      api.reload('2ab69495', component.options)
    }
    module.hot.accept("./ProductGroup.vue?vue&type=template&id=2ab69495&lang=pug&", function () {
      api.rerender('2ab69495', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/sales-flow-ui/components/ProductGroup.vue"
export default component.exports